import React, { useEffect, useState } from 'react';
import NavbarRealtor from '../common/NavBar/NavBarRealtor';
import baseUrl from '../config/config';
import ContentRealtor from './ContentRealtor';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function HomePageRelator(props) {
  var time = null;
  const [isSet, SetIsSet] = React.useState(false)
  const [contactGlobal, setContactGlobal] = useState([])
  const [emailGlobal, setEmailGlobal] = useState([])
  const [calendlyUrl, setCalendlyUrl] = useState([])
  const [addressGlobal, setAddressGlobal] = useState([])
  const urlval = useLocation();

  useEffect(() => {
    let isMounted = true;
    fetch(`${baseUrl.baseUrlCP}get_application_config/`,
      {
        headers: {
          "Authorization": `${process.env.REACT_APP_API_KEY}`,
'Accept-Encoding': 'gzip, deflate',
        }
      })
      .then(async response => {
        const result = await response.json()
        if (response.status === 201 || response.status === 200) {
          result && result.map((res) => {
            if (res.application_config_id === 6) {
              if (isMounted) {
                setContactGlobal(res)
              }
            } else if (res.application_config_id === 5) {
              if (isMounted) {
                setEmailGlobal(res)
              }
            } else if (res.application_config_id === 7) {
              if (isMounted) {
                setCalendlyUrl(res)
              }
            } else if (res.application_config_id === 8) {
              if (isMounted) {
                setAddressGlobal(res)
              }
            }
          })
        }
        else if (response.status === 403) {
        }
      }
      )
      .catch((error) => {
        console.error('error message', error)
      })
    return () => {
      isMounted = false;
    }
  }, [])

  useEffect(() => {
    if (!time) {
      props.timer2();
      time = true;
    }
    return () => props.timer2(urlval);
  }, [props.timer2])

  return (
    <div className={`container-fluid p-0 m-0 ${props.pathname}`}>
      <Helmet>
        <title>{`${props?.pathname?.partner_name} | Calque`}</title>
        <meta name="description" content={`${props?.pathname?.partner_name} has partnered with Calque to bring you a new, innovative lending solution called The Trade-In Mortgage™.`} />
        <meta name="keywords" content="trade in mortgage, trade-in mortgage, trade in loan, trade up mortgage, slide loan, slide mortgage, glide loan, trade my home, home swap, mortgage swap, swamp my home, home trade, buy before you sell, buy-first solution, buy-first, Calque, house swap" />
        <meta property="og:title" content={`${props?.pathname?.partner_name} | Calque`} />
        <meta property="og:description" content={`${props?.pathname?.partner_name} has partnered with Calque to bring you a new, innovative lending solution called The Trade-In Mortgage™.`}/>
        <meta property="og:url" content={`https://tradeinmortgage.com/${props?.pathname?.url_path}`} />
        <link rel="canonical" href={`https://tradeinmortgage.com/${props?.pathname?.url_path}`} />
      </Helmet>
      <NavbarRealtor {...props} contactGlobal={contactGlobal} emailGlobal={emailGlobal} calendlyUrl={calendlyUrl} addressGlobal={addressGlobal} />
      <ContentRealtor {...props} SetIsSet={SetIsSet} isSet={isSet} contactGlobal={contactGlobal} emailGlobal={emailGlobal} calendlyUrl={calendlyUrl} addressGlobal={addressGlobal} partner={props.partner} GAtimer={props.GAtimer} GAtimerFinish={props.GAtimerFinish} partnerContactRole={props.partnerContactRole} condition={props.condition} aboutUsList={props.aboutUsList} conditionList={props.conditionList} defectsList={props.defectsList}/>
    </div>
  )
}